import type { Prototype } from "../prototype-types";

export const jiaTuPrototypes: Prototype[] = [
  {
    id: "jtu-analytics-channels",
    name: "Analytics by channel",
    path: "/jtu/analytics-channels",
    description: "Analytics page that splits Marketplace (commission-bearing) from Faire Direct (commission-free) and breaks Faire Direct down by tool with funnel views and zero-state CTAs.",
    owner: "Jia Tu",
    createdAt: "2026-05-07",
    lastUpdated: "2026-05-07",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/edc58357da60e7b7738650b70271e20cb368a828685402d0f952dcee1f2c41a7.png",
    creationTool: "claude-code",
  },
];
